import type { ComponentProps } from 'react';
import React from 'react';

import { token } from '@atlaskit/tokens';

/**
 * WARNING: Be careful about importing other dependencies in this file because the component is exported directly in index
 */
export const AutomationIcon = (props: ComponentProps<'svg'>): React.JSX.Element => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width="40" height="40" fill={token('color.icon.inverse')} />
		<rect width="40" height="40" rx="3" fill={token('color.background.accent.gray.subtlest')} />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.3399 9.97969C22.7512 9.42098 23.6362 9.78092 23.5408 10.4681L21.7349 23.4699H13.7322C13.1839 23.4699 12.8686 22.8463 13.1937 22.4048L22.3399 9.97969Z"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.4245 18.1148C27.9728 18.1148 28.288 18.7384 27.963 19.1799L18.8168 31.605C18.4055 32.1637 17.5205 31.8038 17.6159 31.1166L19.4217 18.1148H23.976L27.4245 18.1148Z"
			fill={token('color.icon')}
			fillOpacity="0.95"
		/>
	</svg>
);
